
import React from 'react'

import useTranslation from '../../Hooks/UseTranslation'

import './SplashPage.scss'

const SplashPage = () => {

  const { t } = useTranslation()

  return (
    <div className="pl4-splash" role="status" aria-live="polite">
      <div className="pl4-splash__content">
        <div className="pl4-splash__brand">
          <img src="/svg-icons/logo-icon.svg" alt="" />
          <strong>PL<span>4</span>NNER</strong>
        </div>

        <div className="pl4-splash__progress" aria-hidden="true">
          <span />
        </div>

        <p>{t('SPLASH:Loading')}</p>
      </div>
    </div>
  )
}

export default SplashPage
